import { ReactElement, useCallback } from 'react';
import { Button, Popover, Select } from '@ff-it/ui';
import { useOptions } from './fields';
import { useNavigate } from 'react-router';
import { auth, useSession } from 'services';
import { SessionUser } from 'modules/core/types';
import { popoverField, popoverPanel } from './TopNav.css';
import { EmbeddedSelect } from './EmbeddedSelect';

const selectProps = {
  placeholder: 'Impersonation...',
  isClearable: true,
  getOptionLabel: (a: SessionUser) => a.email,
  getOptionValue: (a: SessionUser) => a.id.toString(),
};

export function Impersonation({ compact }: { compact?: boolean }): ReactElement | null {
  const navigate = useNavigate();
  const { user, impersonation } = useSession();

  const loadOptions = useOptions<any>('auth/users/impersonate/');

  const onChange = useCallback(
    (v: any) => {
      auth.impersonation = v;
      navigate('/');
    },
    [navigate],
  );

  // Superuser on impersonate permission in any agency
  if (
    !(
      user?.is_superuser ||
      user?.membership.find((scope) => scope?.kind === 'AGENCY' && scope.permissions.indexOf('core.impersonate') !== -1)
    )
  ) {
    return null;
  }
  const hasValue = !!impersonation;

  const commonProps = {
    ...selectProps,
    loadOptions,
    onChange,
    name: 'impersonate_user',
    id: 'impersonate_user',
    isClearable: false,
    noOptionsMessage: ({ inputValue }: { inputValue: string }) => (inputValue ? 'No matches' : 'Type to search'),
  };

  const field = (
    <>
      <Select size="sm" {...commonProps} value={impersonation} disabled={hasValue} menuPosition="fixed" />
      {hasValue && (
        <Button icon="xmark" variant="ghost" color="danger" size="sm" ml="1" onClick={() => onChange(null)} />
      )}
    </>
  );

  // compact: collapse into an icon popover with an embedded select
  if (compact) {
    return (
      <Popover
        placement="bottom-end"
        content={
          hasValue ? (
            <div className={popoverField}>{field}</div>
          ) : (
            <div className={popoverPanel}>
              <EmbeddedSelect {...commonProps} value={null} />
            </div>
          )
        }
      >
        <Button variant="ghost" size="xs" icon="user-secret" color={hasValue ? 'danger' : undefined} />
      </Popover>
    );
  }

  return <div className="form-inline">{field}</div>;
}
